import { rufe } from './client';

/** GUT-14, GUT-20: was ein Wertgutschein auf einen offenen Betrag anrechnen würde. */
export type Gutscheinvorschau =
  | { readonly gefunden: false }
  | {
      readonly gefunden: true;
      readonly gutschein: {
        readonly id: string;
        readonly nummer: string;
        readonly wert: string;
        readonly restwert: string;
        readonly gueltigBis: string;
        readonly status: string;
      };
      readonly einloesbar: boolean;
      readonly meldung: string | null;
      readonly anrechnung: string;
      readonly restzahlung: string;
      readonly hinweis: string;
    };

/** Prüft einen Code, ohne einzulösen — eingelöst wird erst beim Anlegen der Rechnung. */
export async function vorschau(
  code: string,
  offenerBetrag: string,
  leistungstag: string | null,
): Promise<Gutscheinvorschau> {
  const teile = new URLSearchParams({ offenerBetrag });
  if (leistungstag !== null) teile.set('leistungstag', leistungstag);
  return rufe(`/gutscheine/code/${encodeURIComponent(code)}/vorschau?${teile.toString()}`);
}
